// extracted by mini-css-extract-plugin
export default {"appliedToTable":"RulePanel_appliedToTable__lp6wP"};